import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disableAdd", "disableEdit", "editTooltip", "addTooltip", "isClassicEmailSelected", "moduleContainsFormField", "readOnly", "value"];
/**
 * THE FOLLOWUP EMAIL FIELD IS DEPRECATED
 */

import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import emptyFunction from 'react-utils/emptyFunction';
import { connect } from 'react-redux';
import { debounce, isEqual } from 'underscore';
import I18n from 'I18n';
import Routes from 'ContentUtils/Routes';
import PortalIdParser from 'PortalIdParser';
import AsyncSelector from 'ContentComponents/components/cmv2/components/AsyncSelector';
import { FOLLOW_UP_EMAIL } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import * as EmailsActions from 'ContentData/actions/Emails';
import * as emailsSelectors from 'ContentData/selectors/emails';
import { DEFAULT_PAGE_SIZE, ASYNC_SELECTOR_DEBOUNCE } from 'ContentComponents/components/cmv2/constants';
import withCreateResourceModal from '../decorators/withCreateResourceModal';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import { userInfoSync } from 'hub-http/userInfo';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DecoratedAsyncSelector = withCreateResourceModal(FOLLOW_UP_EMAIL)(AsyncSelector);
const i18nKey = suffix => `ContentComponents.cmv2.fields.followupEmail.${suffix}`;
function makeMapStateToProps() {
  const getIsEmailValid = emailsSelectors.makeGetIsEmailValid();
  const getIsEmailClassic = emailsSelectors.makeGetIsEmailClassic();
  return function mapStateToProps(state, props) {
    return {
      emails: emailsSelectors.getEmails(state),
      options: emailsSelectors.getEmailOptions(state),
      optionsRequestStatus: emailsSelectors.getEmailsCacheRequestStatus(state),
      defaultOptions: emailsSelectors.getDefaultEmailOptions(state),
      isValid: getIsEmailValid(state, {
        id: props.value
      }),
      isClassicEmailSelected: getIsEmailClassic(state, {
        id: props.value
      })
    };
  };
}
const mapDispatchToProps = {
  fetchEmail: EmailsActions.fetchEmail,
  fetchEmails: EmailsActions.fetchEmails,
  clearCache: EmailsActions.clearCache,
  saveCache: EmailsActions.saveCache,
  createResource: EmailsActions.createEmail
};
class FollowupEmail extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onClear = this.onClear.bind(this);
    this.loadOptions = this.loadOptions.bind(this);
    this.setAccessRules = this.setAccessRules.bind(this);
    this.debouncedLoadOptions = debounce(this.loadOptions, ASYNC_SELECTOR_DEBOUNCE);
    this.state = {
      accessRules: {},
      input: ''
    };
  }
  componentDidMount() {
    if (this.props.value) {
      this.props.fetchEmail(this.props.value);
    }
    this.setAccessRules();
  }
  componentDidUpdate(prevProps) {
    const {
      emails,
      error,
      fetchEmail,
      isValid,
      setError,
      value
    } = this.props;
    const {
      isValid: prevIsValid,
      value: prevValue
    } = prevProps;
    if (isValid !== prevIsValid) {
      if (!isValid && value && !this.isDeprecated) {
        setError(I18n.text(i18nKey('unpublishedErrorMessage')));
      } else if (error) {
        setError(null);
      }
    }
    if (!isEqual(prevValue, value) && value && !emails[value]) {
      fetchEmail(value);
    }
  }
  get isDeprecated() {
    return !Routes.isUngated('ContextualAutomation:AllowSelectingLegacyEmails');
  }
  get emailIsSelected() {
    const {
      followupEmailEnabled,
      modulePath,
      value
    } = this.props;
    return modulePath === '@hubspot/form' ? value && followupEmailEnabled : value;
  }
  setAccessRules() {
    const userInfoSyncResult = userInfoSync();
    const scopes = userInfoSyncResult.user.scopes;
    const accessRules = {
      hasClassicEmail: scopes.includes('email-access'),
      hasEditorAccess: scopes.includes('email-editor-access'),
      hasWriteAccess: scopes.includes('email-write'),
      hasEmailDnd: scopes.includes('email-marketing-product-access')
    };
    this.setState({
      accessRules
    });
  }
  loadOptions(input, callback, pagination = {
    offset: 0
  }) {
    let offset = pagination.offset;
    if (input !== this.state.input) {
      this.setState({
        input
      });
      this.props.clearCache();
      offset = 0;
    }
    const query = {
      name__icontains: input,
      limit: DEFAULT_PAGE_SIZE,
      offset
    };
    this.props.fetchEmails(query).then(response => {
      const {
        total
      } = response;
      callback(null, {
        options: this.props.options,
        pagination: {
          hasMore: total > this.props.options.length,
          offset: offset + DEFAULT_PAGE_SIZE,
          length: total
        }
      });
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  onChange({
    target: {
      value
    }
  }) {
    this.props.onFieldChange(value);
  }
  onClear() {
    this.props.onFieldChange(null);
  }
  renderDeprecatedAlert() {
    const {
      moduleContainsFormField,
      revealFormField
    } = this.props;
    if (moduleContainsFormField) {
      return /*#__PURE__*/_jsx(Alert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('deprecatedAlert.followupEmailInFormFieldEnabled.moduleContainsFormField.titleText')
        }),
        type: "warning",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx("div", {
          children: revealFormField ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: i18nKey('deprecatedAlert.followupEmailInFormFieldEnabled.moduleContainsFormField.message_jsx'),
            options: {
              onClick: () => revealFormField()
            },
            elements: {
              Link
            }
          }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: i18nKey('deprecatedAlert.followupEmailInFormFieldEnabled.moduleContainsFormField.message')
          })
        })
      });
    }
    return /*#__PURE__*/_jsx(Alert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('deprecatedAlert.followupEmailInFormFieldEnabled.moduleDoesNotContainFormField.titleText')
      }),
      type: "warning",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
          message: i18nKey('deprecatedAlert.followupEmailInFormFieldEnabled.moduleDoesNotContainFormField.message'),
          options: {
            formAutomation: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('deprecatedAlert.followupEmailInFormFieldEnabled.moduleDoesNotContainFormField.formAutomation')
              })
            }),
            learnMoreLink: /*#__PURE__*/_jsx(Link, {
              external: true,
              href: "https://knowledge.hubspot.com/forms/set-up-and-style-forms-on-hubspot-pages#configure-your-form-automation",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('deprecatedAlert.followupEmailInFormFieldEnabled.moduleDoesNotContainFormField.learnMore')
              })
            })
          }
        }), /*#__PURE__*/_jsx(Button, {
          onClick: this.onClear,
          size: "extra-small",
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('deprecatedAlert.followupEmailSelected.clearFollowupEmailButton')
          })
        })]
      })
    });
  }
  render() {
    const _this$props = this.props,
      {
        disableAdd,
        disableEdit,
        editTooltip,
        addTooltip,
        isClassicEmailSelected,
        moduleContainsFormField,
        readOnly,
        value
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      accessRules
    } = this.state;
    const isDeprecatedAndContainsFormField = this.isDeprecated && moduleContainsFormField;
    if (!accessRules.hasClassicEmail && !accessRules.hasEmailDnd || isDeprecatedAndContainsFormField) {
      return null;
    }
    if (this.isDeprecated) {
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [this.renderDeprecatedAlert(), this.emailIsSelected && /*#__PURE__*/_jsx(AsyncSelector, Object.assign({}, rest, {
          loadOptions: this.debouncedLoadOptions,
          readOnly: true,
          value: value
        }))]
      });
    }
    let actualEditTooltip = editTooltip;
    let actualAddTooltip = addTooltip;
    let actualEditDisable = disableEdit;
    let actualAddDisable = disableAdd;
    if (!accessRules.hasEditorAccess) {
      actualEditTooltip = /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('noReadAccess')
      });
      actualEditDisable = true;
    } else if (!accessRules.hasClassicEmail && isClassicEmailSelected) {
      actualEditTooltip = /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('noEmailClassicAccess')
      });
      actualEditDisable = true;
    }
    if (!accessRules.hasWriteAccess) {
      actualAddTooltip = /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('noWriteAccess')
      });
      actualAddDisable = true;
    }
    return /*#__PURE__*/_jsx(DecoratedAsyncSelector, Object.assign({}, rest, {
      addTooltip: actualAddTooltip,
      createResourceUrl: `/content/${PortalIdParser.get()}/create/email/all?emailType=FORM_FOLLOWUP_EMAIL`,
      disableAdd: actualAddDisable,
      disableEdit: actualEditDisable,
      editTooltip: actualEditTooltip,
      loadOptions: this.debouncedLoadOptions,
      onChange: this.onChange,
      readOnly: readOnly,
      value: value
    }));
  }
}

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof FollowupEmail' is not ass... Remove this comment to see the full error message
FollowupEmail.propTypes = {
  addTooltip: PropTypes.node,
  disableAdd: PropTypes.bool,
  disableEdit: PropTypes.bool,
  editTooltip: PropTypes.node,
  error: PropTypes.bool,
  followupEmailEnabled: PropTypes.bool,
  formId: PropTypes.string,
  moduleContainsFormField: PropTypes.bool,
  modulePath: PropTypes.string,
  onFieldChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  required: PropTypes.bool.isRequired,
  revealFormField: PropTypes.func,
  setError: PropTypes.func,
  showFollowupEmail: PropTypes.bool,
  useOnDark: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /* Connect */
  clearCache: PropTypes.func.isRequired,
  createResource: PropTypes.func.isRequired,
  defaultOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  emails: PropTypes.object.isRequired,
  fetchEmail: PropTypes.func.isRequired,
  fetchEmails: PropTypes.func.isRequired,
  isClassicEmailSelected: PropTypes.bool,
  isValid: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  saveCache: PropTypes.func.isRequired
};
FollowupEmail.defaultProps = {
  defaultOptions: [],
  disableAdd: false,
  disableEdit: false,
  error: false,
  options: [],
  readOnly: false,
  setError: emptyFunction
};
export default connect(makeMapStateToProps, mapDispatchToProps)(FollowupEmail);